import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

export function PhotoModal({ isOpen, toggle, photos }) {
  const [currentIndex, setCurrentIndex] = useState(0);
    const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" centered>
      <ModalHeader toggle={toggle}>{t('PageAdmin.CompanyDeviceRecordTable.Photo')}</ModalHeader>
      <ModalBody style={{ height: "500px", overflow: "hidden" }}>
        {/* Fixed-size photo area */}
        <div
          style={{
            height: "350px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "1rem",
            backgroundColor: "#f8f9fa",
          }}
        >
          <img
            src={photos[currentIndex]}
            alt={`Photo ${currentIndex + 1}`}
            style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
          />
        </div>

        {/* Thumbnails */}
        <div className="d-flex gap-2 overflow-auto">
          {photos.map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Thumb ${i + 1}`}
              className="img-thumbnail"
              style={{
                width: "80px",
                height: "80px",
                border: i === currentIndex ? "2px solid #007bff" : "none",
                cursor: "pointer",
                objectFit: "cover",
              }}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>
      </ModalBody>
    </Modal>
  );
}